import { render, staticRenderFns } from "./needWork.vue?vue&type=template&id=2e61de69&scoped=true&"
import script from "./needWork.vue?vue&type=script&lang=js&"
export * from "./needWork.vue?vue&type=script&lang=js&"
import style0 from "./needWork.vue?vue&type=style&index=0&id=2e61de69&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e61de69",
  null
  
)

export default component.exports